import * as React from 'react';

interface IProps {
  show: boolean;
  searchText: string;
}

export class StubSearch extends React.Component<IProps> {
  public render() {
    if (!this.props.show) {
      return <span />;
    }

    return <div>
      <p>По вашему запросу ничего не найдено</p>
      <p>введен запрос: {this.props.searchText}</p>
      <p>Проверьте, нет ли опечаток.</p>
      <p>Попробуйте переформулировать запрос, используя синонимы или другие слова.</p>
      <p>Воспользуйтесь поиском по тегам.</p>
    </div>;
  }
}
